import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { PolicyAddVehicleUiModule } from '@amfam/policy/add-vehicle/ui';
import { PolicyReplaceVehicleDataAccessModule } from '@amfam/policy/replace-vehicle/data-access';
import { PolicyReplaceVehicleUiModule } from '@amfam/policy/replace-vehicle/ui';
import { PolicySharedModule } from '@amfam/policy/shared';
import { BrandDirectivesModule } from '@amfam/shared/utility/brand';
import { SharedServicesModule } from '@amfam/shared/utility/shared-services';
import { UiKitModule } from '@amfam/ui-kit';

import { replaceVehicleFeatureReducers } from './+state';
import { QuickQuoteFeatureEffects } from './+state/quick-quote-feature/quick-quote-feature.effects';
import { AgentHelpComponent } from './agent-help/agent-help.component';
import { AgentNotificationConfirmationComponent } from './agent-notification-confirmation/agent-notification-confirmation.component';
import { BindVehicleDetailsComponent } from './bind-vehicle-details/bind-vehicle-details.component';
import { FuturePaymentsScheduleComponent } from './future-payments-schedule/future-payments-schedule.component';
import { LoanInfoComponent } from './loan-info/loan-info.component';
import { OnlineBindFailureComponent } from './online-bind-failure/online-bind-failure.component';
import { QuickQuoteComparisonComponent } from './quick-quote-comparison/quick-quote-comparison.component';
import { QuickQuoteContainerComponent } from './quick-quote-container/quick-quote-container.component';
import { QuoteOrBindComponent } from './quote-or-bind/quote-or-bind.component';
import { QuoteVehicleDetailsComponent } from './quote-vehicle-details/quote-vehicle-details.component';
import { ReplaceVehicleConfirmationComponent } from './replace-vehicle-confirmation/replace-vehicle-confirmation.component';
import { ReplaceVehicleExpectationSettingComponent } from './replace-vehicle-expectation-setting/replace-vehicle-expectation-setting.component';
import { ReviewQuoteContainerComponent } from './review-quote-container/review-quote-container.component';
import { ReplaceVehicleRoutes } from './routes/replace-vehicle.routes';
import { UnderwritingQuestionListComponent } from './underwriting-question-list/underwriting-question-list.component';
import { UnderwritingQuestionComponent } from './underwriting-question/underwriting-question.component';
import { YearVinLookupComponent } from './year-vin-lookup/year-vin-lookup.component';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('replace-vehicle-feature', replaceVehicleFeatureReducers), // Another store with the name replaceVehicle already exists
    EffectsModule.forFeature([QuickQuoteFeatureEffects]),
    PolicyReplaceVehicleDataAccessModule,
    UiKitModule,
    SharedServicesModule,
    PolicyReplaceVehicleUiModule,
    ReactiveFormsModule,
    RouterModule.forChild(ReplaceVehicleRoutes),
    PolicyAddVehicleUiModule, // FIXME: Might need to move GracePeriodComponent from add vehicle to a shared module
    BrandDirectivesModule,
    PolicySharedModule
  ],
  declarations: [
    QuickQuoteContainerComponent,
    QuoteVehicleDetailsComponent,
    BindVehicleDetailsComponent,
    QuoteOrBindComponent,
    QuickQuoteComparisonComponent,
    AgentHelpComponent,
    AgentNotificationConfirmationComponent,
    YearVinLookupComponent,
    UnderwritingQuestionListComponent,
    UnderwritingQuestionComponent,
    OnlineBindFailureComponent,
    ReplaceVehicleConfirmationComponent,
    ReplaceVehicleExpectationSettingComponent,
    LoanInfoComponent,
    FuturePaymentsScheduleComponent,
    ReviewQuoteContainerComponent
  ]
})
export class PolicyReplaceVehicleFeatureModule {}
